import { FormGroup, FormControl, Validators } from '@angular/forms';

// core
import { FlagsHelper } from '../../../core/library/flags-helper';

// own module
import { JssTreeNodeType } from './jss-types';

export abstract class LytTreeAbstract {

   protected _parent: LytTreeAbstract = null;
   protected _children: LytTreeAbstract[] = [];

   constructor(
   ) {
   }

   public set parent(parent: LytTreeAbstract) {this._parent = parent; }

   public hasChildren(): boolean {
      return this._children.length > 0;
   }

   // recursive (reve) functions
   public abstract reveDumpLytTree(indent: string);
}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/model/lyt-tree-abstract.ts